<template>
	<div id="app" @contextmenu.prevent>
		<div v-cloak>
			<!-- Nav -->
			<template v-if="!isMaintenance">
				<identify-browser></identify-browser>
				<!-- <main-nav v-if="isLoggedIn && isNavbarVisible && !isHideMainNav"></main-nav> -->
				<!-- <mobile-nav v-if="isLoggedIn"></mobile-nav>  -->
			</template>
			<div class="app-wrapper d-flex">
				<!-- Side Nav -->
				<!-- <side-nav
					:user="user"
					v-if="user && isDrawerVisible && !isHide">
				</side-nav> -->
				<!-- Side Nav mobile -->
				<!-- <side-nav-admin-mobile
					v-if="isSuperAdmin && smallScreen">
				</side-nav-admin-mobile> -->
				<!-- Page Loader -->
				<div class="page-loader p-5" v-if="!user && !isRouteAllowed && !isHide">
					<div class="is-loading large dark"></div>
				</div>
				<!-- Main Route View -->
				<main
					:class="{ 'main': isDrawerVisible }"
					v-if="(isRouteAllowed || !!user) &&  (activeRouteName !== 'TemplateEditor')">
					<!-- Announcement -->
					<announcement-notification v-if="isLoggedIn && activeRouteNameWithoutLive && (activeRouteName !== 'RundownEditor')">
					</announcement-notification>
					<router-view />
				</main>
				<!-- Template Editor Route View -->
				<main
					v-if="(isRouteAllowed || !!user) &&  (activeRouteName === 'TemplateEditor')">
					<router-view />
				</main>
			</div>
			<!-- Notifications -->
			<notifications group="app" :ignoreDuplicates="true" position="bottom right" :max="3" :duration="5000" class="notif-index" :closeOnClick="true">
				<template slot="body" slot-scope="props">
					<a v-if="activeRouteName === 'UploadLottie' || activeRouteName === 'RundownEditor'" @click="props.close" class="absolute pointer notif-close-icon">
						<i class="material-icons text-white icon">close</i>
					</a>
					<div class="vue-notification" :class="props.item.type">
						<div class="d-flex justify-space-between">
							<div v-if="props.item.type === 'warning'" class="material-icons text-yellow mr-2 mtb-a">error_outline</div>
							<div v-if="props.item.type === 'success'" class="material-icons text-green mr-2 mtb-a">check</div>
							<div v-if="props.item.type === 'error'" class="material-icons text-red mr-2 mtb-a">clear</div>
							<div v-if="props.item.type === 'disconnect'" class="material-icons text-red mr-2 mtb-a"><wifi-off></wifi-off></div>
							<!-- <div class="title pt-1">{{ props.item.title }} </div> -->
							<!-- <span class="mr-1 ml-1 pt-1"> - </span> -->
							<div class="title pt-1 max-w210" v-html="props.item.text"></div>
							<!-- <div class="title pt-1 max-w210">{{ props.link }}</div> -->
						</div>
					</div>
				</template>
			</notifications>
			<!-- Navigation Drawer -->
			<navigation-drawer></navigation-drawer>
			<!-- Footer -->
			<footer
				class="footer footer-main"
				v-if="isLoggedIn && isDrawerVisible && !isHide">
				<div class="d-flex justify-content-between">
					<div>
						<!-- <div class="footer-image">
							<img src="/img/logo-small.png" alt="LMS" class="d-inline-block align-top">
						</div> -->
						<!-- <div class="footer-brand">{{ appName }} - {{ $t('Copyright') }} © 2019 LO Media.</div> -->
						<div class="footer-brand text-grey"><span>{{ $t('Ver.') }} {{ appVersion }}</span></div>
					</div>
					<div>
						<div class="text-grey text-right">
							<a href="https://grafi.as/terms-and-conditions/" target="_blank" class="link-plain text-grey">{{ $t('Terms & Conditions') }}</a> |
							<a href="https://grafi.as/privacy-policy/" target="_blank" class="link-plain text-grey">{{ $t('Privacy Policy') }}</a> |
							<a href="https://grafi.as/end-user-license-agreement/" target="_blank" class="link-plain text-grey">{{ $t('EULA') }}</a> |
							<a href="https://grafi.as/gdpr-policy-complaints/" target="_blank" class="link-plain text-grey">{{ $t('GDPR Complaints') }}</a>
						</div>
					</div>
				</div>
			</footer>
			<!-- Modals -->
			<!-- <div class="modals"> -->
				<!-- Role Switcher -->
				<!-- <role-switcher v-if="isRoleSwitcherVisible" /> -->
				<!-- Help -->
				<!-- <help-modal v-if="isHelpVisible" /> -->
			<!-- </div> -->
			<cookie-law
				v-if="activeRouteNameWithoutLive"
				theme="primary"
				:message="$t('This website makes use of cookies to enhance browsing experience and provide additional functionality')"
				:buttonText="$t('Accept Cookies')"
				:storageName="'cookieConsent'"
				:storageType="'localStorage'">
			</cookie-law>
			<div v-if="activeRouteNameWithoutLive">
				<identify-network></identify-network>
			</div>
			<!-- update service worker -->
			<transition name="fade">
				<div class="service-worker" v-if="isShowUpdate && activeRouteNameWithoutLive">
					<div class="gradient"></div>
					<div class="material-icons text-grey mr-2 mt-2 pointer ab-tr text-lg" @click="updateExists = false">close</div>
					<div class="material-icons text-grey ml-2 mt-4 pt-4 mtb-a absolute">loop</div>
					<div class="title-service-worker">
						<span class="text-grey">{{$t('A new version of Grafias is')}}</span>
						<div class="text-grey">{{$t('available')}}</div>
					</div>
					<div class="subtitle-service-worker">
						<span class="text-grey">{{$t('Refresh to get latest version')}}</span>
					</div>
					<button
						@click="refreshApp"
						class="btn-refresh">
						{{ $t('Refresh') }}
					</button>
				</div>
			</transition>
		</div>
		<div v-if="isTourVisible && activeRouteNameWithoutLive && !this.activeRouteName.includes('login') && user">
			<tour :steps="tourData[indexTourData]" :text="text" :theme="theme" @close="openModalCloseTour" :isCacheEnabled="true" :isScaled="isFirsTimeLogin" :versioningCacheImage="5">
				<template slot="loading-preview">
					<img src="/img/loading-grafias.gif" alt="LMS" class="d-inline-block align-top">
				</template>
				<!-- only show this topic if related topics containing assets -->
				<template slot="additional-link">
					<label v-if="indexTourData > 4" class="text-primary mt-1 pointer related-topic-font-scaled" @click="goToRelated('Parent Controller')">Learn more on parent controller</label>
				</template>
				<template slot="topics" class="related-topics">
					<div class="absolute footer-bg">
						<div class="ml-4 mr-4 mt-3">
							<div class="d-flex mb-1 related-topic-scaled">
								<div v-tooltip.left="$t('Restart Onboarding')" @click="goToRelated('Quickstart')" class="pointer wrapper-icon-restart">
									<svg class="absolute icon-restart" style="width:24px;height:24px" viewBox="0 0 24 24">
										<path fill="#FFA800"  d="M12,4C14.1,4 16.1,4.8 17.6,6.3C20.7,9.4 20.7,14.5 17.6,17.6C15.8,19.5 13.3,20.2 10.9,19.9L11.4,17.9C13.1,18.1 14.9,17.5 16.2,16.2C18.5,13.9 18.5,10.1 16.2,7.7C15.1,6.6 13.5,6 12,6V10.6L7,5.6L12,0.6V4M6.3,17.6C3.7,15 3.3,11 5.1,7.9L6.6,9.4C5.5,11.6 5.9,14.4 7.8,16.2C8.3,16.7 8.9,17.1 9.6,17.4L9,19.4C8,19 7.1,18.4 6.3,17.6Z" />
									</svg>
								</div>
								<div class="hr-section mr-2 ml-2"></div>
								<div class="text-primary mt-1 related-topic-font-scaled">Click related topics to learn more</div>
							</div>
							<div class="flex-related related-topic-font-scaled related-topic-scaled">
								<div class="related-topic-text pointer item-related" v-for="(related, key) in convertRelated(relatedTopics[indexTourData].topic)" :key="key">
									<div @click="goToRelated(related)" class="mr-1">
										<span>{{related}}</span>
										<span v-if="key + 1 !== convertRelated(relatedTopics[indexTourData].topic).length">,</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</template>
			</tour>
		</div>
		<!-- Close Tour Confirmation -->
		<modal
			size="small"
			@close="setFirstTimeLogin"
			v-if="isShowWarningCloseTour">
			<template slot="header">
				{{ $t('Onboarding') }}
			</template>
			<template slot="body">
				<div>{{ $t('You can access onboarding window from profile menu, on the top right side') }}</div>
			</template>
			<template slot="footer">
				<div class="w-100 flex-center">
					<button class="btn btn-primary" :class="{ 'is-loading': isClosingTour }" @click="setFirstTimeLogin">
						{{ $t('OK') }}
					</button>
				</div>
			</template>
		</modal>
	</div>
</template>

<script>
import Tour from 'vue-tour-kiki';
import 'vue-tour-kiki/dist/vue-tour.css';
import { mapGetters, mapActions } from 'vuex';
import CookieLaw from 'vue-cookie-law';
import wifiOff from 'vue-material-design-icons/WifiStrengthOffOutline.vue';
// import MainNav from '@/components/MainNav.vue';
// import MobileNav from '@/components/MobileNav.vue';
import Modal from '@/components/Modal.vue';
// import SideNav from '@/components/SideNav.vue';
import AnnouncementNotification from '@/components/AnnouncementNotification.vue';
// import SideNavAdminMobile from '@/components/SideNavAdminMobile.vue';
import NavigationDrawer from '@/components/NavigationDrawer.vue';
import IdentifyNetwork from '@/components/IdentifyNetwork.vue';
import IdentifyBrowser from '@/components/IdentifyBrowser.vue';
import authApi from '@/api/auth';
import usersApi from '@/api/user';
import rundownsApi from '@/api/rundowns';
import { delay, duplicateVar, getAxiosErrorMessage } from './lib/helper';
import {
	appVersion,
	tourData,
	relatedTopics,
} from '@/lib/statics';

// const NOTIF_PERMISSION_GRANTED = 'notif_granted';
const NETWORK_EVENTS = ['online', 'offline', 'load'];

export default {
	name: 'App',
	components: {
		CookieLaw,
		// MainNav,
		// MobileNav,
		// SideNav,
		// SideNavAdminMobile,
		NavigationDrawer,
		IdentifyNetwork,
		IdentifyBrowser,
		wifiOff,
		AnnouncementNotification,
		Tour,
		Modal,
	},
	data() {
		return {
			mode: 'normal',
			isFooterVisible: false,
			isNotChrome: false,
			// service worker
			refreshing: false,
			registration: null,
			updateExists: false,
			smallScreen: false,
			showMobileNav: false,
			tourData,
			relatedTopics,

			text: {
				next_cta: 'NEXT',
				prev_cta: 'PREV',
				restart_cta: 'RESTART',
			},
			theme: {
				color: '#FFA800',
				radius: '2px',
			},
			blurEl: '.can-tour-blur',
			debug: true,
			storage: 'custom-local-storage',
			isShowWarningCloseTour: false,
			isClosingTour: false,
			isGetDataFirstLogin: false,
			isFirsTimeLogin: false,
			// set settings user
			settings: null,
			isEnableAdvance: false,
			isEnableDummy: true,
			isEnableAllPreview: false,
			isEnableShowLogo: false,
			isTourVisible: false,
			lastCategoryTemplate: 0,
			lastKeywordTemplate: '',
			lastCategoryGallery: 0,
			lastKeywordGallery: '',
			indexTourData: 0,
			section: '',
		};
	},
	methods: {
		...mapActions({
			fetchUser: 'fetchUser',
			setOnlineStatus: 'setOnlineStatus',
			setRole: 'setRole',
			setDrawerVisible: 'setDrawerVisible',
			setUser: 'setUser',
		}),
		init() {
			// Notification Prompt
			// this.requestNotifPermission();
			// Fetch user if logged in
			if (this.isLoggedIn && !this.user) this.fetchUser();
		},

		// requestNotifPermission() {
		// 	const isGranted = localStorage.getItem(NOTIF_PERMISSION_GRANTED);
		// 	if (!isGranted) {
		// 		Notification.requestPermission().then((result) => {
		// 			if (result === 'denied' || result === 'default') {
		// 				if (result === 'denied') {
		// 				} else if (result === 'default') {
		// 				}
		// 			} else {
		// 				// Do something with the granted permission.
		// 				localStorage.setItem(NOTIF_PERMISSION_GRANTED, true);
		// 			}
		// 		});
		// 	}
		// },
		initSocketSubs() {
			const userId = this.user.id;
			// Global Channel
			this.$socket.client.emit('join', 'global');
			// Other Channels
			const channels = this.getSocketChannels(userId);
			for (let index = 0; index < channels.length; index++) {
				const channel = channels[index];
				this.$socket.client.emit('join', channel);
			}
			this.$options.sockets.joined = () => {
				// eslint-disable-next-line
				// if (data.indexOf(userId) !== -1) {
				// 	this.testBroadcast();
				// }
			};
		},
		getSocketChannels(userId) {
			const prefixes = ['user'];
			const channels = prefixes.map(prefix => `${prefix}_${userId}`);
			return channels;
		},
		testBroadcast() {
			// const userId = this.user.id;
			// const params = {
			// 	roomId: `user_${userId}`,
			// 	channel: 'notification_add',
			// 	payload: { yeah: 'yeah' },
			// };
			// const callback = () => {};
			// const errorCallback = () => {};
			// broadcastApi.create(params, callback, errorCallback);
		},
		updateOnlineStatus() {
			const isOnline = navigator.onLine || false;
			this.setOnlineStatus(isOnline);
		},
		checkUI() {
			const hideSidebar = this.$route.meta.hideSidebar;
			// Drawer
			this.setDrawerVisible(!hideSidebar);
		},
		// checkActiveRouteName() {
		// 	return this.activeRouteName
		// 	&& !this.activeRouteName.includes('Display')
		// 	&& !this.activeRouteName.includes('Live')
		// 	&& !this.activeRouteName.includes('Preview')
		// 	&& !this.activeRouteName.includes('CompositionEditorView');
		// },
		checkBrowser() {
			if (this.activeRouteNameWithoutLive) {
				// if ((this.$browserDetect.isChrome || this.$browserDetect.isChromeIOS)) {
				// } else {
				// 	this.isNotChrome = false;
				// }
			}
			this.isNotChrome = true;
		},
		showRefreshUI(e) {
			// Display a button inviting the user to refresh/reload the app due to an app update being available.
			delay(() => {
				this.registration = e.detail;
				this.updateExists = true;
			}, 300000);
		},
		refreshApp() {
			window.location.href = window.location.href;
			this.updateExists = false;
			// Protect against missing registration.waiting.
			if (!this.registration || !this.registration.waiting) { return; }
			this.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
		},
		onResizeWidth() {
			if (window.innerWidth <= 1024) {
				this.smallScreen = true;
			} else {
				this.smallScreen = false;
			}
		},
		setSettingsData() {
			// @TODO: catch variable user setting if setting is undefined
			const settings = JSON.parse(this.user.settings);
			if (settings) {
				const settingsString = this.user.settings;
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				this.isEnableAdvance = settings && settings.is_enable_advance_layout ? duplicateVar(settings.is_enable_advance_layout) : false;
				this.isEnableDummy = settings && settings.is_enable_dummy_item_data ? duplicateVar(settings.is_enable_dummy_item_data) : false;
				this.isEnableAllPreview = settings && settings.is_enable_all_preview ? duplicateVar(settings.is_enable_all_preview) : false;
				this.isEnableShowLogo = settings && settings.is_enable_show_logo ? duplicateVar(settings.is_enable_show_logo) : false;
				this.isShowTour = settings && settings.is_tour_visible ? duplicateVar(settings.is_tour_visible) : false;
				this.lastCategoryTemplate = settings && settings.last_category_template ? duplicateVar(settings.last_category_template) : 0;
				this.lastKeywordTemplate = settings && settings.last_keyword_template ? duplicateVar(settings.last_keyword_template) : '';
				this.lastCategoryGallery = settings && settings.last_category_gallery ? duplicateVar(settings.last_category_gallery) : 0;
				this.lastKeywordGallery = settings && settings.last_keyword_gallery ? duplicateVar(settings.last_keyword_gallery) : '';
			} else {
			// @TODO: catch variable user setting if setting is undefined
				const settingsString = this.user.settings;
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				this.isEnableAdvance = 0;
				this.isEnableDummy = 0;
				this.isEnableAllPreview = 0;
				this.isEnableShowLogo = 0;
				this.isShowTour = false;
				this.lastCategoryTemplate = 1;
				this.lastKeywordTemplate = '';
				this.lastCategoryGallery = 1;
				this.lastKeywordGallery = '';
			}
		},
		async closeTour() {
			await this.setSettingsData();
			this.settings.is_enable_advance_layout = this.isEnableAdvance;
			this.settings.is_enable_dummy_item_data = this.isEnableDummy;
			this.settings.is_enable_all_preview = this.isEnableAllPreview;
			this.settings.is_enable_show_logo = this.isEnableShowLogo;
			this.settings.is_tour_visible = false;
			this.settings.last_category_template = this.lastCategoryTemplate;
			this.settings.last_keyword_template = this.lastKeywordTemplate;
			this.settings.last_category_gallery = this.lastCategoryGallery;
			this.settings.last_keyword_gallery = this.lastKeywordGallery;
			// this.settings.background_color = this.colorBackground;
			const paramsSettings = { settings: JSON.stringify(this.settings) };
			const layout = paramsSettings;
			const params = layout;
			const callback = (response) => {
				const user = response.data;
				this.setUser(user);
				this.isShowWarningCloseTour = false;
			};
			const errorCallback = () => {
			};
			authApi.updateProfile(params, callback, errorCallback);
		},
		openModalCloseTour() {
			if (this.isFirsTimeLogin) {
				this.isShowWarningCloseTour = true;
			} else {
				this.closeTour();
			}
		},
		setFirstTimeLogin() {
			const callback = () => {
				this.closeTour();
			};
			const errorCallback = () => {
			};
			usersApi.setLogin(callback, errorCallback);
		},
		convertRelated(data) {
			const topic = JSON.stringify(data);
			const result = JSON.parse(topic);
			return result;
		},
		goToRelated(section) {
			this.section = section;
			if (section === 'Quickstart') { this.indexTourData = 0; if (this.$route.path !== '/rundowns') { this.$router.push('/rundowns').catch(() => {}); } }
			if (section === 'Rundown') { this.indexTourData = 1; if (this.$route.name !== 'RundownEditor') { this.getQuickRundown(); } }
			if (section === 'Rundown Settings') { this.indexTourData = 2; if (this.$route.name !== 'RundownEditor') { this.getQuickRundown(); } }
			if (section === 'Output in-Depth') { this.indexTourData = 3; if (this.$route.path !== '/displays') { this.$router.push('/displays').catch(() => {}); } }
			if (section === 'Collaboration') { this.indexTourData = 4; if (this.$route.path !== '/collaborators') { this.$router.push('/collaborators').catch(() => {}); } }
			if (section === 'Asset Lower Third' || section === 'Lower Third') { this.indexTourData = 5; if (this.$route.name !== 'RundownEditor') { this.getQuickRundown(); } }
			if (section === 'Media') { this.indexTourData = 6; if (this.$route.name !== 'RundownEditor') { this.getQuickRundown(); } }
			if (section === 'Lottie') { this.indexTourData = 7; if (this.$route.name !== 'RundownEditor') { this.getQuickRundown(); } }
			if (section === 'Ticker') { this.indexTourData = 8; if (this.$route.name !== 'RundownEditor') { this.getQuickRundown(); } }
			if (section === 'Timer') { this.indexTourData = 9; if (this.$route.name !== 'RundownEditor') { this.getQuickRundown(); } }
			if (section === 'Audio') { this.indexTourData = 10; if (this.$route.name !== 'RundownEditor') { this.getQuickRundown(); } }
			if (section === 'Marker') { this.indexTourData = 11; if (this.$route.name !== 'RundownEditor') { this.getQuickRundown(); } }
			if (section === 'Video Input') { this.indexTourData = 12; if (this.$route.name !== 'RundownEditor') { this.getQuickRundown(); } }
			if (section === 'Browser Source') { this.indexTourData = 13; if (this.$route.name !== 'RundownEditor') { this.getQuickRundown(); } }
			if (section === 'Custom Command') { this.indexTourData = 14; if (this.$route.name !== 'RundownEditor') { this.getQuickRundown(); } }
			if (section === 'Composition') { this.indexTourData = 15; if (this.$route.name !== 'RundownEditor') { this.getQuickRundown(); } }
			if (section === 'Parent Controller') { this.indexTourData = 16; }
		},
		getQuickRundown() {
			// redirect to rundown editor
			const callback = (response) => {
				const item = response.data;
				if (item) {
					this.$router.push(`/rundowns/editor/${btoa(item.slug)}`);
				} else {
					this.getLastRundown();
				}
			};
			const errorCallback = () => {
			};
			rundownsApi.getQuickRundown(callback, errorCallback);
		},
		getDataFirstLogin() {
			if (this.user && this.user.is_first_time_login) {
				// eslint-disable-next-line
				return this.isFirsTimeLogin = true;
			}
			// eslint-disable-next-line
			return this.isFirsTimeLogin = false;
		},
		getLastRundown() {
			const params = {
				limit: 1,
				order_by: 'created_at',
				sort_by: 'asc',
				user_id: this.user.id,
			};
			const callback = (response) => {
				const item = response.data;
				if (item && item[0] && item[0].slug) this.$router.push(`/rundowns/editor/${btoa(item[0].slug)}`);
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: this.$t(this.title),
					text: message,
				});
			};
			rundownsApi.getList(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isLoggedIn: 'isLoggedIn',
			isOnline: 'isOnline',
			isHelpVisible: 'isHelpVisible',
			isRoleSwitcherVisible: 'isRoleSwitcherVisible',
			isDrawerVisible: 'isDrawerVisible',
			isNavbarVisible: 'isNavbarVisible',
			isSuperAdmin: 'isSuperAdmin',
		}),
		isShowUpdate() {
			return this.updateExists;
		},
		isHide() {
			const isRundownCreate = this.$route.name === 'isRundownCreate';
			const isRundownEditor = this.$route.name === 'isRundownEditor';
			const isNull = this.$route.name === null;
			const isLive = this.$route.name === 'Live';
			const isPreview = this.$route.name === 'Preview';
			const isMulti = this.$route.name === 'MultiviewOutputDisplay';
			const isOnPath = isRundownCreate || isRundownEditor || isPreview || isLive || isMulti || isNull;
			return isOnPath;
		},
		isHideMainNav() {
			const isNull = this.$route.name === null;
			const isLive = this.$route.name === 'Live';
			const isPreview = this.$route.name === 'Preview';
			const isMulti = this.$route.name === 'MultiviewOutputDisplay';
			const isOnPath = isPreview || isLive || isMulti || isNull;
			return isOnPath;
		},
		isRouteAllowed() {
			const routePath = this.$route.path;
			const isIndex = routePath === '/';
			const isDisplayLive = this.$route.name === 'DisplayLive';
			const isDisplayItem = this.$route.name === 'StreamDisplayItemRundown';
			const isDisplayMulti = this.$route.name === 'MultiviewOutputDisplay';
			const isLightStream = this.$route.name === 'LightStream';
			const isAllowed = isIndex
				|| routePath === '/maintenance'
				|| routePath === '/login'
				|| routePath === '/register'
				|| routePath === '/magic-link'
				|| routePath === '/change-password'
				|| routePath === '/confirmation-email'
				|| routePath === '/auto_login'
				|| routePath === '/user/verify'
				|| isDisplayLive
				|| isDisplayItem
				|| isDisplayMulti
				|| isLightStream
				|| routePath.indexOf('/password/reset') !== -1;
			return isAllowed;
		},
		isMaintenance() {
			const routePath = this.$route.path;
			return routePath === '/maintenance';
		},
		showVersion() {
			return process.env.VUE_APP_SHOW_VERSION;
		},
		appName() {
			return process.env.VUE_APP_NAME;
		},
		appVersion() {
			return appVersion;
		},
		activeRouteName() {
			return this.$route.name;
		},
		activeRouteNameWithoutLive() {
			return this.activeRouteName
			&& !this.activeRouteName.includes('DisplayLive')
			&& !this.activeRouteName.includes('Live')
			&& !this.activeRouteName.includes('Preview')
			&& !this.activeRouteName.includes('LightStream')
			&& !this.activeRouteName.includes('CompositionEditorView')
			&& !this.activeRouteName.includes('MultiviewOutputDisplay');
		},
	},
	watch: {
		$route(to, from) {
			this.checkUI();
			if (to.path === '/' && from.path === '/login') {
				this.init();
			}

			// Add Class To Body
			const prevClassName = `page-${from.name}`;
			const nextClassName = `page-${to.name}`;
			document.body.classList.remove(prevClassName);
			document.body.classList.add(nextClassName);
		},
		// role(role) {
		// 	document.body.classList.remove('role-admin', 'role-teacher', 'role-student', 'role-branch_leader');
		// 	document.body.classList.add(`role-${role}`);
		// },
		user() {
			if (this.user) this.initSocketSubs();
			if (this.user && this.user.settings) {
				const settings = JSON.parse(this.user && this.user.settings);
				this.isTourVisible = JSON.parse(settings.is_tour_visible ? settings.is_tour_visible : false);
				this.getDataFirstLogin();
			}
			if (this.user) this.setSettingsData();
		},
		// '$route.name': {
		// 	handler() {
		// 		this.mode = this.$route.name || 'normal';
		// 		// Footer
		// 		if (this.$route.name !== 'RundownCreate') {
		// 			this.isFooterVisible = true;
		// 		} else {
		// 			this.isFooterVisible = false;
		// 		}
		// 	},
		// },
	},
	created() {
		this.checkUI();
		this.checkBrowser();
		this.init();
		this.getDataFirstLogin();
		NETWORK_EVENTS.forEach(event => window.addEventListener(event, this.updateOnlineStatus));
		// service worker
		document.addEventListener('swUpdated', this.showRefreshUI, { once: true });
		// Refresh all open app tabs when a new service worker is installed.
		navigator.serviceWorker.addEventListener('controllerchange', () => {
			if (this.refreshing) return;
			this.refreshing = true;
			// window.location.reload();
		});
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
	},
	destroyed() {
		NETWORK_EVENTS.forEach(event => window.removeEventListener(event, this.updateOnlineStatus));
	},
	mounted() {
	},
};
</script>

<style lang="scss">
	@import './assets/scss/base.scss';
	[v-cloak] {
		display: none;
	}
</style>
